var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c;
import getLanguageFromStorage from 'syf-js-utilities/helpers/getLanguageFromStorage';
import { hasNotLoggedIn } from '../helpers/hasLoggedIn';
import config from './config';
var IS_LOCAL_DEV = (_b = (_a = import.meta.env) === null || _a === void 0 ? void 0 : _a.DEV) !== null && _b !== void 0 ? _b : false;
var selectedEnv = (_c = sessionStorage.getItem('mma-mfe__selected-env')) !== null && _c !== void 0 ? _c : 'qa';
var mockBaseURL = 'https://49d5d9c8-78b0-4215-8f68-f813590e693f.mock.pstmn.io';
var apigeeURL = "https://api-".concat(selectedEnv, ".syf.com");
var akamaiURL = 'https://images.synchronycredit.com';
var APP_ENV = config.APP_ENV.startsWith('CF_')
    ? 'development'
    : config.APP_ENV;
export var assetsURL = config.ASSETS_HOST.startsWith('CF_')
    ? akamaiURL
    : config.ASSETS_HOST;
var serviceFileConfigPath = {
    nonprod: 'serviceFiles/json/nonprod-mma-config.json',
    prod: 'serviceFiles/json/prod-mma-config.json',
    sandbox: 'serviceFiles/json/dev/mma-config.json'
};
export var assetsBaseURL = "".concat(assetsURL, "/assets/account-activity-mfe/");
var serviceFilesURL = "".concat(assetsURL, "/").concat(serviceFileConfigPath.sandbox);
// Default fallback config if not provided by channel app
export var activityConfig = {
    apiErrorCallback: function () { return null; },
    hosts: {
        apigee: new URL(apigeeURL),
        assets: new URL(assetsURL),
        serviceFile: new URL(serviceFilesURL)
    },
    lang: getLanguageFromStorage()
};
/*
 * Use getSandboxConfig to avoid getting an outdated
 * sandboxConfig when a component is rendered
 */
export var getSandboxConfig = function () {
    var notLoggedIn = hasNotLoggedIn();
    var apiURL = notLoggedIn ? mockBaseURL : apigeeURL;
    var currentConfigPath = IS_LOCAL_DEV
        ? serviceFileConfigPath.nonprod
        : serviceFileConfigPath.sandbox;
    var currentServiceFilesURL = "".concat(notLoggedIn ? mockBaseURL : assetsURL, "/").concat(currentConfigPath);
    return {
        apiErrorCallback: function () { return null; },
        hosts: {
            apigee: new URL(apiURL),
            assets: new URL(assetsURL),
            serviceFile: new URL(currentServiceFilesURL)
        },
        lang: getLanguageFromStorage()
    };
};
// This sandboxConfig is used only by test cases
export var sandboxConfig = getSandboxConfig();
export var getDisputesConfig = function (mmaConfig) {
    var serviceFilesDisputesUrl = APP_ENV === 'production'
        ? "".concat(akamaiURL, "/serviceFiles/json/prod-disputes-config.json")
        : "".concat(akamaiURL, "/serviceFiles/json/nonprod-disputes-config.json");
    return __assign(__assign({}, mmaConfig), { hosts: __assign(__assign({}, mmaConfig.hosts), { serviceFile: new URL(serviceFilesDisputesUrl) }) });
};
export default activityConfig;
//# sourceMappingURL=activity-config.js.map